import { Formik, FormikProps } from "formik";
import { useRef, useState } from "react";
import { useMutation } from "react-query";
import { PlusIcon } from "..";
import { brochureSchema } from "../../../Schema/CommerceCompassSchema";
import AGButton from "../../../components/Button";
import { CloseIcon } from "../../../components/ComfirmModal/modal.styled";
import AGModal from "../../../components/Modal";
import { useNotification } from "../../../components/Notification";
import { FirmProfile } from "../../../models";
import { httpPUT } from "../../../utils/ajaxHelper";
import {
	FileBorder,
	FileLable,
	FileName,
	FormContainer,
} from "./addBrochure.styled";
import { isEqual } from "lodash";

export interface AddBrochureModalProps {
	visible: boolean;
	toggleModal: () => void;
	data: FirmProfile;
}
const AddBrochureModal = ({
	visible,
	toggleModal,
	data,
}: AddBrochureModalProps) => {
	const handleClose = () => {
		toggleModal();
	};
	const { showNotification } = useNotification();
	const formRef = useRef<FormikProps<any>>(null);
	const fileRef = useRef<HTMLInputElement>(null);
  	const [isDataChanged,setIsDataChanged] = useState<boolean>(false);

	const { mutate: submitForm } = useMutation(
		(data: FormData) =>
			httpPUT({
				url: "/FirmProfile",
				data: data,
			}),
		{
			onSuccess: (rs) => {
				handleClose();
			},
			onError: (rs) => {
				showNotification("Upload Failed", "Error");
			},
		},
	);

	if (!data) {
		return null;
	}

	const intitialValues = {
		isDeleteBrochure: false,
		fkFirmId: data?.fkFirmId,
		logoName: data?.logoName,
		logoPart: data?.logoPart,
		backgroundName: data?.backgroundName,
		backgroundPart: data?.backgroundPart,
		description: data?.description,
		tagLine: data?.tagLine,
		brochureName: data?.brochureName,
		brochurePath: data?.brochurePath,
		videoUrl: data?.videoUrl,
		firmContactstring: data?.firmContactstring,
		offerorURL: data!.offerorURL,
	}

	return (
		<div>
			<AGModal
				toggleModal={() => {
					toggleModal();
				}}
				title="Organization Brochure"
				footer={
					<>
						<AGButton
							type="Primary"
							onClick={() => {
								formRef.current?.submitForm();
							}}
							disabled={!isDataChanged}
							>
							Save
						</AGButton>
					</>
				}
				visible={visible}
				setHeight={240}>
				<FormContainer>
					<Formik
						innerRef={formRef}
						initialValues={
							{
								isDeleteBrochure: false,
								fkFirmId: data?.fkFirmId,
								logoName: data?.logoName,
								logoPart: data?.logoPart,
								backgroundName: data?.backgroundName,
								backgroundPart: data?.backgroundPart,
								description: data?.description,
								tagLine: data?.tagLine,
								brochureName: data?.brochureName,
								brochurePath: data?.brochurePath,
								videoUrl: data?.videoUrl,
								firmContactstring: data?.firmContactstring,
								offerorURL: data!.offerorURL,
							} as any
						}
						validateOnBlur={false}
						validationSchema={brochureSchema}
						onSubmit={(values) => {
							const formData = new FormData();
							formData.append("fkFirmId", values.fkFirmId);
							formData.append("pdf", values.pdf);
							formData.append(
								"isDeleteBrochure",
								values.isDeleteBrochure,
							);
							formData.append(
								"description",
								values.description ? values.description : "",
							);
							formData.append(
								"tagLine",
								values.tagLine ? values.tagLine : "",
							);
							formData.append(
								"videoUrl",
								values.videoUrl ? values.videoUrl : "",
							);
							formData.append(
								"offerorURL",
								values.offerorURL ? values.offerorURL : "",
							);
							submitForm(formData);
						}}>
						{({ values, errors, setFieldValue }) => {

							const isDirty = !isEqual(
								{ ...values
								},
								intitialValues
							);
			
							setIsDataChanged(isDirty);
			
							const hasPdfError =
							typeof errors.pdf === 'string' ? errors.pdf.length > 0 :
							Array.isArray(errors.pdf) ? errors.pdf.length > 0 :
							false;
							
							setIsDataChanged(hasPdfError ? false : isDirty);
							
							return (
								<form onSubmit={(e) => e.preventDefault()} className="form">
									<div className="btn-ctn">
										<label className="label-title-second">
											Upload an organization brochure (PDF file) that highlights the organization.
										</label>
										{!data.pdfDislayName && (
											<FileBorder>
												<FileLable htmlFor="">
													{!values.pdf?.name &&
														!data!
															.pdfDislayName && (
															<AGButton
																icon={
																	<PlusIcon />
																}
																type={"Link"}
																onClick={() =>
																	fileRef.current?.click()
																}>
																Upload Brochure
																PDF
															</AGButton>
														)}

													<FileName>
														{values.pdf?.name && (
															<>
																<div className="flex">
																	<p className="file-name">
																		{
																			values
																				.pdf
																				.name
																		}
																	</p>
																	<div
																		className="cont-delete-icon flex"
																		onClick={() => {
																			if (
																				fileRef.current &&
																				fileRef
																					.current
																					.files
																			) {
																				fileRef.current.value =
																					"";
																				setFieldValue(
																					"pdf",
																					undefined,
																				);
																			}
																		}}>
																		<CloseIcon className="delete-icon-brochure">
																			x
																		</CloseIcon>
																	</div>
																</div>
															</>
														)}
													</FileName>
													<input
														ref={fileRef}
														accept=".pdf"
														id="pdf"
														onChange={(event) => {
															setFieldValue(
																"pdf",
																event.target
																	.files
																	? event
																			.target
																			.files[0]
																	: undefined,
															);
															setFieldValue(
																"isDeleteBrochure",
																false,
															);
														}}
														style={{
															display: "none",
														}}
														type="file"
													/>
												</FileLable>
											</FileBorder>
										)}

										{data.pdfDislayName && (
											<div className="flex pt-[10px]">
												<p className="file-name">
													{data.pdfDislayName}
												</p>
												<div
													className="cont-delete-icon flex"
													onClick={() => {
														data.pdfDislayName = "";
														setFieldValue(
															"isDeleteBrochure",
															true,
														);
														setFieldValue(
															"pdf",
															undefined,
														);
													}}>
													<CloseIcon className="delete-icon-brochure">
														x
													</CloseIcon>
												</div>
											</div>
										)}
										{errors.pdf && (
											<div className="error">
												{errors.pdf.toString()}
											</div>
										)}
									</div>
								</form>
							);
						}}
					</Formik>
				</FormContainer>
			</AGModal>
		</div>
	);
};
export default AddBrochureModal;
